<div class="findings">
  <div class="table-actions">
    @if (pageFilters()) {
      <app-ai-findings-filters class="full-width" [pageFilters]="pageFilters()!"></app-ai-findings-filters>
    }
  </div>
  <div class="table-header">
    @if (viewToggle() === THREADS_VIEW) {
      @if (totalThreads() > -1 && totalFindings() > -1) {
        <div class="resources-amount">
          {{ 'common.found' | labelsProvider }} {{ totalThreads() }} threads with findings
        </div>
      }
    } @else {
      @if (totalFindings() > -1) {
        <div class="resources-amount">
          @if (isUnifiedPipelineEnabled && hasPreventedCount()) {
            ({{ 'common.found' | labelsProvider }} {{ totalFindings() }} findings, {{ preventedCount() }} Prevented)
          } @else {
            {{ 'common.found' | labelsProvider }} {{ totalFindings() }} findings
          }
        </div>
      }
    }

    <div class="table-header-right">
      @if (isThreadsViewEnabled) {
        <div class="toggle-container">
          <app-option-toggle
            [selectedOption]="viewToggle()"
            option1Text="Threads"
            option2Text="Individuals"
            option1Icon="messages-square"
            option2Icon="list"
            (optionChange)="switchView($event)"
          />
        </div>
      }

      @if (isUnifiedPipelineEnabled) {
        <div class="toggle-container">
          <app-option-toggle
            [selectedOption]="sourceToggle()"
            option1Text="Audit Log"
            option2Text="In-Line"
            option1Icon="radar"
            option2Icon="brain"
            (optionChange)="switchSource($event)"
          />
        </div>
      }
    </div>
  </div>

  <div class="table">
    @if (pageFilters()) {
      <app-ai-findings-vertical-filters
        [ngClass]="{ 'filters-all': isFiltersMenuOpen() }"
        (optionOnSelection)="tablesFiltersChange($event)"
        [pageFilters]="pageFilters()!"
        [isFiltersMenuOpen]="isFiltersMenuOpen()"
        (filtersOnMenuStateChange)="isFiltersMenuOpen.set($event)"
      />
    }

    @if (viewToggle() === THREADS_VIEW) {
      <app-enterprise-ai-threads-table
        (totalItems)="totalThreads.set($event)"
        [sourceToggle]="sourceToggle()"
        [ngClass]="!isFiltersMenuOpen() ? 'table-collapsed-menu' : 'table-component'"
      />
    } @else {
      <app-enterprise-ai-findings-table
        (totalItems)="totalFindings.set($event)"
        (blockActionsCount)="onBlockActionsCount($event)"
        [sourceToggle]="sourceToggle()"
        [ngClass]="!isFiltersMenuOpen() ? 'table-collapsed-menu' : 'table-component'"
      />
    }
  </div>
</div>
